import { _ } from "../../core/polyglot/polyglot.js";
import ForecastBalanceSheet from "../../models/forecast/interpretation/reports/ForecastBalanceSheet.js";
import ForecastCashFlow from "../../models/forecast/interpretation/reports/ForecastCashFlow.js";
import ForecastIncomeStatement from "../../models/forecast/interpretation/reports/ForecastIncomeStatement.js";

/**
 * Represent the information required to publish a forecast.
 *
 * @param {string} name - The desired name for the published forecast
 * @param {string} description - Some HTML content describing the main
 *   requirements for the published forecast
 */
export default class ForecastPublicationRequest {
	constructor({ name, description }) {
		this._name = name;
		this._description = description;

		this._reportTemplates = {
			incomeStatement: true,
			balanceSheet: true,
			cashFlow: true,
		};
	}

	getName() {
		return this._name;
	}

	setName(name) {
		this._name = name;
	}

	getDescription() {
		return this._description;
	}

	setDescription(description) {
		this._description = description;
	}

	isIncomeStatementIncluded() {
		return this._reportTemplates.incomeStatement;
	}

	setIncomeStatementInclusion(boolean) {
		this._reportTemplates.incomeStatement = boolean;
	}

	isBalanceSheetIncluded() {
		return this._reportTemplates.balanceSheet;
	}

	setBalanceSheetInclusion(boolean) {
		this._reportTemplates.balanceSheet = boolean;
	}

	isCashFlowIncluded() {
		return this._reportTemplates.cashFlow;
	}

	setCashFlowInclusion(boolean) {
		this._reportTemplates.cashFlow = boolean;
	}

	asIgnoredReports() {
		const ignoredReports = [];

		if (!this._reportTemplates.incomeStatement)
			ignoredReports.push(ForecastIncomeStatement.getType());

		if (!this._reportTemplates.balanceSheet)
			ignoredReports.push(ForecastBalanceSheet.getType());

		if (!this._reportTemplates.cashFlow)
			ignoredReports.push(ForecastCashFlow.getType());

		return ignoredReports;
	}

	validate({ collector }) {
		const atLeastOneTemplateEnabled = Object.values(
			this._reportTemplates,
		).some(Boolean);

		collector.addErrorIf(
			!atLeastOneTemplateEnabled,
			_("At least one report template must be enabled."),
		);
	}
}
